const Chainable = require('./index.js')

window.Chainable = Chainable
module.exports = Chainable
